<template>
    <div
        id="stripe-element-mount-point"
        :class="{ 'form-control': true, 'is-invalid': state === false }"
    />
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'StripeCard',
        props: {
            clientSecret: {
                type: String,
                required: true,
            },
            publishableKey: {
                type: String,
                required: true,
            },
            stripeAccount: {
                type: String,
                required: true,
            },
            state: {
                type: Boolean,
                default: null,
            },
        },
        computed: {
            ...mapGetters('stripe', ['stripe', 'card']),
        },
        mounted() {
            (async () => {
                await this.$store.dispatch('stripe/loadStripeCard', {
                    clientSecret: this.clientSecret,
                    publishableKey: this.publishableKey,
                    stripeAccount: this.stripeAccount,
                });
                this.card.mount('#stripe-element-mount-point');

                this.card.on('change', this.onElementChange);
                this.card.on('ready', this.onElementReady);
            })();
        },
        methods: {
            onElementChange(event) {
                this.$emit('element-change', event);
            },
            onElementReady(event) {
                this.$emit('element-ready', event);
            },
        },
    };
</script>
